import { FC } from 'react'

import RefreshIcon from '@mui/icons-material/Refresh'
import Card, { CardProps } from '@mui/material/Card'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

interface BaseChartCardProps {
  title?: string
  refresh?: () => void
  cardProps?: CardProps
}

const BaseChartCard: FC<BaseChartCardProps> = ({
  children,
  title,
  refresh,
  cardProps,
}) => {
  const theme = useTheme()
  const showHeader = Boolean(title || refresh)

  return (
    <Card
      sx={{
        p: 3,
        height: '100%',
        boxShadow: 'none',
        border: `1px solid ${theme.palette.grey[300]}`,
      }}
      {...cardProps}
    >
      {showHeader && (
        <Stack direction="row" justifyContent="space-between" mb={2}>
          {title ? (
            <Typography variant="h6" fontWeight={600}>
              {title}
            </Typography>
          ) : (
            <span />
          )}

          {refresh && (
            <IconButton onClick={refresh}>
              <RefreshIcon />
            </IconButton>
          )}
        </Stack>
      )}

      {children}
    </Card>
  )
}

export default BaseChartCard
